import { UserRoleType } from "../types/roles-and-permissions.types";

/**
 * Öğrenen (Kursiyer = USER(3), Stajyer = INTERN(5)) rol tiplerine verilebilecek
 * izinlerin KATI izin listesi (pentest 3.2.2).
 *
 * BU LİSTE BACKEND İLE BİREBİR AYNI OLMALIDIR:
 *   euas-backend/src/modules/permissions/constants/learner-permissions.constant.ts
 *   (LEARNER_PAGE_MODULES + LEARNER_ACTION_PERMISSIONS)
 *
 * Backend, 3/5 tipindeki bir role bu liste dışında izin verilmesini
 * 400 `errors.PERMISSION_NOT_ALLOWED_FOR_ROLE_TYPE` ile reddeder. Buradaki kopya
 * yalnızca UI'da ilgili kutuları kapatmak ve kaydetmeden önce temizlemek için
 * vardır; asıl kontrol sunucudadır. Backend listesi değişirse burayı da güncelle.
 *
 * Not: Her personel HR senkronu ile Kursiyer rolünü de taşır ve izinler
 * rollerin birleşimidir; öğrenen rolüne verilen her izin tüm personele geçer.
 */
export const LEARNER_ALLOWED_PERMISSION_KEYS: ReadonlySet<string> = new Set([
  // ── PAGE (modül ana anahtarı) ──
  "ANNOUNCEMENTS.PAGE",
  "EDUCATIONS.PAGE",
  "EXAMS.PAGE",
  "SURVEYS.PAGE",
  "SUPPORT_TICKETS.PAGE",
  "FILES.PAGE",
  "LIBRARY.PAGE",
  // ── Aksiyonlar ──
  "ANNOUNCEMENTS.VIEW",
  "EDUCATIONS.VIEW",
  "FILES.VIEW",
  "FILES.CREATE",
  "LIBRARY.VIEW",
  "SUPPORT_TICKETS.VIEW",
  "SUPPORT_TICKETS.CREATE",
  "ROLES.VIEW",
  "DEPARTMENTS.VIEW",
  "NOTIFICATIONS.VIEW",
  "NOTIFICATIONS.MARK_READ",
  "NOTIFICATION_PREFERENCES.VIEW",
  "NOTIFICATION_PREFERENCES.UPDATE",
  "DEVICE_TOKENS.VIEW",
  "DEVICE_TOKENS.REGISTER",
  "DEVICE_TOKENS.DELETE",
  "OTP_VERIFICATIONS.VIEW",
  "OTP_VERIFICATIONS.CREATE",
  "OTP_VERIFICATIONS.VERIFY",
  "REFRESH_TOKENS.VIEW",
  "REFRESH_TOKENS.CREATE",
  "REFRESH_TOKENS.REVOKE",
  "SURVEY_ATTEMPTS.VIEW",
  "SURVEY_ATTEMPTS.CREATE",
  "SURVEY_ATTEMPTS.UPDATE",
  "SURVEY_QUESTIONS.VIEW",
]);

/** İzin listesi kısıtının uygulandığı rol tipleri. */
export const LEARNER_RESTRICTED_ROLE_TYPES: readonly number[] = [
  UserRoleType.USER,
  UserRoleType.INTERN,
];

export const isLearnerRestrictedRoleType = (
  type: number | null | undefined,
): boolean =>
  type !== null &&
  type !== undefined &&
  LEARNER_RESTRICTED_ROLE_TYPES.includes(type);

/** Verilen rol tipine bu izin verilebilir mi? (Personel tiplerinde her zaman true.) */
export const isPermissionAllowedForRoleType = (
  key: string,
  type: number | null | undefined,
): boolean =>
  !isLearnerRestrictedRoleType(type) ||
  LEARNER_ALLOWED_PERMISSION_KEYS.has(key);

/** Rol tipine verilemeyen izinleri ayıklar (personel tiplerinde dokunmaz). */
export const stripDisallowedForRoleType = (
  keys: Iterable<string>,
  type: number | null | undefined,
): Set<string> => {
  const result = new Set<string>();
  for (const key of keys) {
    if (isPermissionAllowedForRoleType(key, type)) result.add(key);
  }
  return result;
};
